import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type * as variableOverrides from '../../../variable-overrides'

import type { Feature } from '../feature'
import { State } from '../state'
import { getDraftVariableHolder } from './get-draft-variable-holder'

/**
 * Focuses scenario variables when a route-bound scenario draft opens.
 */
export const focusVariablesOnCreate = store.effects.create(
  (
    feature: Feature,
    meFeature: me.Feature,
    variableOverridesFeature: variableOverrides.Feature,
  ) =>
    feature.actions.openCreate.observe().pipe(
      rxjs.withLatestFrom(meFeature.contexts.selectors.appContext.asObservable),
      rxjs.mergeMap(([action, appContext]) => {
        if (!appContext) {
          return rxjs.EMPTY
        }

        const holder = getDraftVariableHolder({
          appId: appContext.appId,
          scenarioId: State.CREATE_DRAFT_SCENARIO_ID,
        })

        return rxjs.of(
          variableOverridesFeature.actions.setFocused
            .from(action)
            .create(holder),
          variableOverridesFeature.actions.putValues.from(action).create({
            holder,
            values: {},
          }),
        )
      }),
    ),
)
